import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { authApi } from './api';

export default function Login({ onForgot }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-brand">D2D</div>
        <h1>Oil &amp; Gas Asset OS</h1>
        <p className="auth-lead">
          AI operating system for the full lifecycle — evaluate, value, raise from independent
          sponsors, acquire, manage, operate, optimize, and sell.
        </p>
        <p className="auth-lead auth-lead-secondary">
          Capital tape and raise packs for independent sponsors. Non-advisory AI — humans decide.
        </p>
        {error && <div className="auth-error">{error}</div>}
        <label>
          Email
          <input
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label>
          Password
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        <button type="submit" className="auth-primary" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        <button type="button" className="auth-link" onClick={onForgot}>
          Forgot password?
        </button>
        <p className="auth-fine">Confidential under CA · 2FA required · Data2Dollars.ai</p>
      </form>
    </div>
  );
}

export function ForgotPassword({ onBack }) {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await authApi.forgot(email.trim());
      setDone(true);
    } catch (err) {
      setError(err.message || 'Request failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-brand">D2D</div>
        <h1>Reset password</h1>
        <p className="auth-lead">
          Enter your email and we will send a reset link via Amazon SES if an account exists.
        </p>
        {error && <div className="auth-error">{error}</div>}
        {done ? (
          <div className="auth-ok">
            If that email is registered, a reset link is on its way. Check spam/junk.
          </div>
        ) : (
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
        )}
        {!done && (
          <button type="submit" className="auth-primary" disabled={busy}>
            {busy ? 'Sending…' : 'Send reset email'}
          </button>
        )}
        <button type="button" className="auth-link" onClick={onBack}>
          Back to sign in
        </button>
      </form>
    </div>
  );
}
